import GameObject from "../modules/GameObject";
import GraphicObject from "../modules/GraphicObject";
import LivingObject from "../modules/LivingObject";
import TickingObject from "../modules/TickingObject";


export default class World<T> {

	canvas = undefined as (undefined | T)
	items = [] as GameObject[]
	lastStamp = Date.now()

	tick(deltaProp?: (undefined | number)) {
		let delta: number
		if (deltaProp) {
			delta = deltaProp
		} else {
			const now = Date.now()
			this.lastStamp = now
			delta = ((now - this.lastStamp) / 1000)
		}

		const items = this.getItems()
		items.forEach(item => {
			if (item instanceof TickingObject) {
				item.tick(delta)
			}
		})

		// remove dead objects
		this.items = this.items.filter(item => {
			if (item instanceof LivingObject) {
				if (item.isDead) {
					if (this.canvas && (item instanceof GraphicObject)) {
						item.removeGraphics()
					}
					item.dispose()
					return false
				}
				return true
			} else {
				return true
			}
		})
	}

	add(item: GameObject) {
		this.items.push(item)
		if (this.canvas) {
			if (item instanceof GraphicObject) {
				item.addGraphics(this.canvas)
			}
		}
	}

	remove(item: GameObject) {
		this.items = this.items.filter(i => i !== item)
		if (this.canvas) {
			if (item instanceof GraphicObject) {
				item.removeGraphics()
			}
		}
	}

	getItems() {
		return [...this.items]
	}

	bindCanvas(canvas: (undefined | T)) {
		const items = this.getItems()

		if (canvas) {
			// bind canvas

			items.forEach(item => {
				if (item instanceof GraphicObject && !item.graphicsMounted) {
					item.addGraphics(canvas)
				}
			})
		} else {
			// unbind canvas

			if (this.canvas) {
				items.forEach(item => {
					if (item instanceof GraphicObject && item.graphicsMounted) {
						item.removeGraphics()
					}
				})
			}
		}

		this.canvas = canvas;
	}

	dispose() {
		this.bindCanvas(undefined)

		this.items.forEach(item => item.dispose())

		this.items = []
	}

}